import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		videoPlayer: {
			position        : props?.isVideoEnded ? "relative" : "static",
			border          : theme.other.darkMode ? `0.5px solid ${ theme.other.paletteNew.darkModeWhite20 }` : "unset",
			borderRadius    : "1rem",
			backgroundColor : theme.other.colors.background.primary,
			overflow        : "hidden",
			aspectRatio     : "16/9",

			[rooterMediaQuery.mobile]: {
				position     : "sticky",
				top          : "70px",
				zIndex       : 100,
				borderRadius : "unset",
				border       : "unset"
			}
		},
		feedInfoContaier: {
			padding: "0 1.2rem"
		},
		multiMediaContainer: {
			position  : "absolute",
			top       : "50%",
			left      : "50%",
			transform : "translate( -50%, -50% )",
			zIndex    : 10,
			width     : "300px"

		},
		timeLeft: {
			fontSize     : "1.5rem",
			fontWeight   : "500",
			marginBottom : "1rem",
			color        : theme.other.paletteNew.secondaryWhite

		},
		buttonContainer: {
			display    : "flex",
			alignItems : "center",
			float      : "right",
			marginTop  : "1rem"
		},
		cancelButton: {
			color: theme.other.paletteNew.primaryDarkBlue
		},
		cancelText: {
			fontWeight : "500",
			fontSize   : "1.5rem"
		},
		padding: {
			paddingTop: "1rem"
		},
		overlay: {
			background   : theme.other.paletteNew.secondaryBlack,
			height       : "100%",
			width        : "100%",
			position     : "absolute",
			zIndex       : 1,
			borderRadius : "1rem",

			[rooterMediaQuery.mobile]: {
				borderRadius: "0"
			}
		},
		bottomDetailsTitleClass: {
			color: theme.other.paletteNew.secondaryWhite
		}
	};
} );
